<template>

  <CRow>
    <CCol>
      <CCard class="bg-style2">
        <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
          <span  class="font-weight-bold h6"><CIcon name="cil-layers" size="lg"/> {{caption}}</span>
          <div class="card-header-actions">
            <small class="font-weight-bold ">Total : {{this.itemse.length}}</small>
          </div>
        </CCardHeader>
        <CCardBody>
          <CDataTable
              :table-filter="{label:'Code'}"
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              :items="(this.itemse.length > 0)?this.itemse:[]"
              :fields="fields"
              :items-per-page="small ? 50 : 5"
              :dark="dark"
              pagination
          >


            <template #no="{index,item}">
              <td>
                <div class="text-center">{{index+1}}</div>
              </td>
            </template>

            <template #lastUpdate="{item}">
              <td>
                <div class="text-center">{{(item.lastUpdate != null)?item.lastUpdate:"-"}}</div>
              </td>
            </template>



            <template #view="{item}">
              <td>
                <CRow >
                  <CCol class="" v-if="item.isCreate.length != 0" >
                    <!--                {{item.isCreate[0].first}}-->
                    <!--                status : {{item.isCreate[0].status}}-->

                    <CButton :disabled="(onCheckViewPDF(item,1) != true)?true:false" class="mr-3 succ" size="sm" :color="(onCheckViewPDF(item,1) != true)?'dark':'info'" shape="pill" variant="outline" @click="onGetInfoView(item)">
                      {{$t('button.view',{index: item.isCreate[0].tqfType})}}
                    </CButton>
                    <CButton v-if="(onCheckViewPDF(item,1) == true)?true:false" :disabled="(onCheckViewPDF(item,2) != true)?true:false" class="mr-3 succ " size="sm" :color="(onCheckViewPDF(item,2) != true)?'dark':'warning'" shape="pill" variant="outline" @click="onGetInfoViewF(item)">
                      {{$t('button.view',{index: item.isCreate[0].tqfTypeF})}}
                    </CButton>
                  </CCol>

                </CRow>
              </td>
            </template>

            <template #Clone="{item}">
              <td>
                <CRow >
                  <CCol class="text-center" >
                    <CButton :disabled="!onCheckCalendar('before',item.code)" v-if="item.isCreate.length != 0"  class="mr-3 " size="sm" color="primary" shape="pill" variant="outline" @click="onCLone(item)">
                      {{$t('button.clone',{index: item.isCreate[0].tqfType})}}
                    </CButton>
                  </CCol>

                </CRow>
              </td>
            </template>


            <template ##="{item}">
              <td>
                <CRow>
                  <CCol >
                    <div class="text-center">
                      <div class="float-left" >


                        <CButton class="mr-1" size="sm" color="success" shape="pill" variant="outline" @click="onDescription(item)" >
                          <CIcon name="cil-description"/>
                        </CButton>
                      </div>

                    </div>
                  </CCol>
                </CRow>
              </td>
            </template>

          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import {mapGetters} from "vuex";
import moment from 'moment'

export default {
  name: 'CourseOfInstructors',
  props: {
    option:false,
    status: {
      type: Boolean,
      default: false
    },
    items:  {
      type: Object,
    },
    fields: {
      type: Array,
      default() {
        return [
          {key: 'no', label: "ID", _style: 'text-align: center, width:40px'},
          {key: 'code', label: 'Code'},
          {key: 'name', label: 'Name'},
          {key: 'credit', label: 'Credit'},
          // {key: 'view', label: 'View', _style: 'text-align: center'},
          // {key: 'Clone', label: 'Clone', _style: 'text-align: center'},
          {key: '#', label: "#", _style: 'text-align: center, width:50xp'}
        ]
      }
    },
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },

  data: function () {
    return {
      itemse : []
    }
  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
      objsCampus : "campus/campus",
      objsCourse : "courses/course",
    })
  },
  methods: {
    onDescription(item){

      var objs = {};
      objs.code = item.value.code;
      objs.title = item.value.title;
      objs.credit =item.value.credit;

      var modification = {};
      modification.dateTime =  moment().format("DD MMMM YYYY HH:mm");
      modification.by = "sos"
      objs.modification = modification;


      objs.studentsYearofStudy = [];
      objs.campus = [];

      this.$store.commit("tqf/general",objs)

      var objs = {};
      objs.description = item.value.description;

      var hoursPerSemester = {};
      hoursPerSemester.lecture = 0;
      hoursPerSemester.lab = 0;
      hoursPerSemester.selfStudy = 0;

      objs.objectives = "";
      objs.improvement = "";

      objs.hoursPerSemester = hoursPerSemester;


      this.$store.commit("tqf/syllabus",objs)



    }


  },
  watch : {

    objsCourse(value){
      var items = [];
      value.filter(item => {
        var objs = item.title.filter(title => {
          if(title.key == this.lang){
            return title
          }
        })[0].value;

        var data = {};
        data.code = item.code
        data.name = objs
        data.credit = item.credit


        var objs =  item;

        data.value = objs;

        items.push(data)
      })
      this.itemse = items;
    },
  }
}
</script>
